import { defineComponent } from "vue";
import { Container } from "aurelia-dependency-injection";

import { AnalyticsService, AnalyticsCategory } from "../../services/analytics.service";

import TabsAnimatedHeader from "../../resources-vue/vue-custom-elements/TabsAnimatedHeader/TabsAnimatedHeader.vue";

type IRoute = {
    path: string;
    name: string;
    meta: {
        menuName: string;
        navItem: string;
    };
};
type ItemRef = {
    [key: string]: Element;
};

export default defineComponent({
    components: {
        TabsAnimatedHeader
    },

    props: ["router"],

    data() {
        return {
            _analyticsServices: null as AnalyticsService,
            itemRefs: {} as ItemRef,
            element: null as HTMLElement
        };
    },
    created() {
        this._analyticsServices = Container.instance.get(AnalyticsService);
    },
    computed: {
        getActiveItem() {
            return this.element;
        }
    },

    methods: {
        addItemRefs(el: Element, route: IRoute) {
            this.itemRefs[route.meta.navItem] = el;
            this.element = this.itemRefs[this.$route.meta.navItem as string] as HTMLElement;
        },

        isActivePath(path: string) {
            return this.$route.matched?.some((route) => route.path == path);
        },

        goTo(route: any, path: string) {
            this._analyticsServices.logEvent({
                category: AnalyticsCategory.CentralMenuPages,
                action: route.meta.menuName
            });
            this.$router.push(path);
        }
    }
});
